document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.select-tabs')) return;
    event.preventDefault();
    var tab = event.target;
    var tabParent = event.target.parentNode;
    var tabWrapper = tabParent.parentNode;
    var desktopTabs = tabParent.previousElementSibling;
    var desktopTabItems = desktopTabs.querySelectorAll('li'),
        i;
    var tabContent = tabWrapper.querySelectorAll('.wc-tab, .panel:not(.panel .panel'),
        j;

    for (i = 0; i < desktopTabItems.length; ++i) {
      desktopTabItems[i].classList.remove('active');
    }

    desktopTabs.querySelector('a[href="#' + tab.value + '"]').parentElement.classList.add('active'); //keeping the normal ul li list up to date

    for (j = 0; j < tabContent.length; ++j) {
      tabContent[j].style.display = 'none';
    }

    tabWrapper.querySelector('#' + tab.value).style.display = 'block'; //show the tab with the id of the value of the option chosen
  }, false);
  document.addEventListener('click', function (event) {
    if (!event.target.matches('.wc-tabs li a, ul.tabs li a')) return; //extending the current woo function for this to update the custom mobile select dropdown 

    event.preventDefault();
    var tab = event.target;
    var tabValue = tab.getAttribute('href');
    var selectValue = tabValue.replace('#', '');
    var mobileTabs = document.querySelector('.select-tabs');
    mobileTabs.value = selectValue; //update the select with this value 
  }, false);
});
document.addEventListener('DOMContentLoaded', function () {
  var link = document.querySelector('#trustpilot-reviews-link');

  if (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector(link.getAttribute('href'));

      if (target) {
        var targetOffset = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({
          top: targetOffset,
          behavior: 'smooth'
        });
        target.classList.add('active');
        var siblings = Array.from(target.parentNode.children);
        siblings.forEach(function (sibling) {
          if (sibling !== target) {
            sibling.classList.remove('active');
          }
        });
        var tabContent = document.querySelector('#tab-trustpilot_reviews_tab');

        if (tabContent) {
          tabContent.style.display = 'block';
          var tabSiblings = Array.from(tabContent.parentNode.querySelectorAll('.woocommerce-Tabs-panel'));
          tabSiblings.forEach(function (sibling) {
            if (sibling !== tabContent) {
              sibling.style.display = 'none';
            }
          });
        }

        var select = document.querySelector('.select-tabs');

        if (select) {
          var option = select.querySelector('option[value="tab-trustpilot_reviews_tab"]');

          if (option) {
            option.selected = true;
          }
        }
      }
    });
  }
});